import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface SecondaryIpsProps {
  onSubmit: () => void;
  endpointNode: string;
  ips: string;
}
export const SecondaryIps = ({ onSubmit, endpointNode, ips }: SecondaryIpsProps) => {
  const api = useApi();
  const [secondaryIps, setSecondaryIps] = React.useState(ips);

  const ipPost = useMutation(api.addEndpointNodeSecondaryIpsApiV1AddEndpointNodeSecondaryIpsPost, {
    onSuccess(data) {
      toast.success('Secondary IP added successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    ipPost.mutate({
      ep_node_id: endpointNode,
      secondary_ips: secondaryIps,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        id="secondary-ips"
        label="Secondary IPs"
        variant="outlined"
        sx={{ mb: 4 }}
        value={secondaryIps}
        onChange={(e) => setSecondaryIps(e.target.value)}
        autoFocus
        helperText="Enter comma separated IPs"
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Add Secondary IPs
        </Button>
      </Box>
    </Box>
  );
};
